import { render, staticRenderFns } from "./CartProduct.vue?vue&type=template&id=753119b2&scoped=true"
import script from "./CartProduct.vue?vue&type=script&lang=js"
export * from "./CartProduct.vue?vue&type=script&lang=js"
import style0 from "./CartProduct.vue?vue&type=style&index=0&id=753119b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753119b2",
  null
  
)

export default component.exports